<div *ngIf="dataLoading" class="d-loading fadeIn animated">
    <div class="loader">Loading ...</div>
</div>

<div *ngIf="!dataLoading && loadError" class="animated fadeIn">
    <h4 class="mb-1" style="font-size: 17px;">Payable Details</h4>
    <div class="text-danger font-weight-bold">This payable is no longer available.</div>
    <div class="text-muted">The related payable record may have been deleted. No further action is needed — if you believe this is an error, please contact support.</div>
</div>

<div *ngIf="!dataLoading && !loadError && payable" class="animated fadeIn">
    <h4 class="mb-1" style="font-size: 17px;">
        Payable Details<span class="text-sm text-muted">{{ transaction.description ? (': ' + transaction.description) : ''}}</span>
        <span *ngIf="payable.deletedAt" class="text-danger"> (Deleted {{ payable.deletedAt | legfiDate: 'MM/DD/YYYY' }})</span>
    </h4>
    <div class="row">
        <div class="col-12 col-lg-6 col-xl-2">
            <div class="section-header">Vendor</div>
            <ng-container *ngIf="payable.vendor; else noVendor">
                <div>
                    <a [routerLink]="['/app/vendor/details', payable.vendor.id]">
                        <span>{{ payable.vendor.name }}</span>
                        <span *ngIf="payable.vendor.nickname"> ({{ payable.vendor.nickname }})</span>
                    </a>
                </div>
                <div>
                    <span>{{ payable.vendor.address1 }}</span>
                    <span *ngIf="payable.vendor.address2">, {{ payable.vendor.address2 }}</span>
                </div>
                <div>
                    <span>{{ payable.vendor.city }}, {{ payable.vendor.state }} {{ payable.vendor.zip }}</span>
                </div>
            </ng-container>
            <ng-template #noVendor>
                <div class="text-muted">No vendor on file</div>
            </ng-template>
        </div>
        <div class="col-12 col-lg-6 col-xl-2">
            <div class="section-header">Invoice</div>
            <div>
                <span class="font-weight-bold">Invoice # </span>
                <span>{{ payable.invoiceNumber ?? '--' }}</span>
            </div>
            <div>
                <span class="font-weight-bold">Invoice Date: </span>
                <span>{{ payable.invoiceDate | legfiDate: 'MM/DD/YYYY' }}</span>
            </div>
            <div>
                <span class="font-weight-bold">Amount: </span>
                <span>{{ (payable.amount | legfiCurrency:'USD':'symbol':'.2') }}</span>
            </div>
            <div>
                <span class="font-weight-bold">Due Date: </span>
                <span>{{ payable.dueDate | legfiDate: 'MM/DD/YYYY' }}</span>
            </div>
        </div>
        <div class="col-12 col-lg-6 col-xl-4">
            <div class="section-header">Payment</div>
            <div>
                <span class="font-weight-bold">Bank Account: </span>
                <span>{{ payable.currentFulfillment?.fundingBankAccount?.friendlyName
                         ?? payable.currentFulfillment?.vendorBankAccount?.friendlyName
                         ?? 'no account selected' }}</span>
            </div>
            <div>
                <span class="font-weight-bold">Transaction #: </span>
                <span>{{ payable.currentFulfillment?.fulfillmentReference?.payabliTransactionNumber || payable.currentFulfillment?.fulfillmentReference?.checkNumber || 'N/A' }}</span>
            </div>
            <div *ngIf="payable.currentFulfillment?.fulfillmentReference?.trackingNumber">
                <span class="font-weight-bold">Tracking #: </span>
                <span>{{ payable.currentFulfillment.fulfillmentReference.trackingNumber }}</span>
            </div>
            <div *ngIf="transaction.transactionDate">
                <span class="font-weight-bold">Transaction Date: </span>
                <span>{{ transaction.transactionDate | legfiDate:'MM/DD/YYYY' }}</span>
            </div>
            <div *ngIf="payable.currentFulfillment?.paymentSentAt">
                <span class="font-weight-bold">Date Paid: </span>
                <span>{{ payable.currentFulfillment.paymentSentAt.format('MM/DD/YYYY') }}</span>
            </div>
            <div *ngIf="payable.expectedDeliveryDate">
                <span class="font-weight-bold">Expected Delivery: </span>
                <span>{{ payable.expectedDeliveryDate.format('MM/DD/YYYY') }}</span>
            </div>
            <div *ngIf="payable.currentFulfillment?.paymentMethodType || payable.paymentType">
                <span class="font-weight-bold">Payment Type: </span>
                <span>{{ payable.currentFulfillment?.paymentMethodType || payable.paymentType }}</span>
            </div>
            <div>
                <span class="font-weight-bold">Amount: </span>
                <span>{{ (payable.amount | legfiCurrency:'USD':'symbol':'.2') }}</span>
            </div>
            <div *ngIf="payable.currentFulfillment?.action">
                <span class="font-weight-bold">Action: </span>
                <span>{{ payable.currentFulfillment.action }}</span>
            </div>
            <div class="d-flex align-items-center">
                <span class="font-weight-bold mr-1">Payment Status:</span>
                <div class="pl-2 d-flex align-items-center">
                    <app-payable-status-badge [payable]="payable"></app-payable-status-badge>
                </div>
            </div>
        </div>
        <div class="col-12 col-lg-6 col-xl-4 pr-5">
            <div class="section-header">Categories</div>
            <div *ngFor="let split of payable.expenseCategories; trackBy: trackByExpenseCategory" class="mt-2">
                <div class="d-flex justify-content-between border-bottom border-bottom-1 mb-1">
                    <div>{{ split.expenseCategory.label }}</div>
                    <div>{{ (split.expenseCategoryAmount | legfiCurrency:'USD':'symbol':'.2') ?? 'n/a' }}</div>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="showMemo" class="row mt-2 mb-3">
        <div class="col-12" style="line-height: 1.5rem;">
            <div>
                <span class="font-weight-bold">Payable Memo: </span>
                <span>{{ payable?.memo }}</span>
            </div>
        </div>
    </div>
</div>
